const url = 'treatment-crud';
import { api } from 'api';
import Swal from 'sweetalert2';
import { push } from 'react-router-redux';
import { goBack } from 'react-router-redux';
import { initialize as initializeForm } from 'redux-form';
import { createActions, handleActions } from 'redux-actions';

const LOADER_TREATMENT = 'LOADER_TREATMENT';
const SET_DATA_TREATMENT = 'SET_DATA_TREATMENT';
const SET_PAGE_TREATMENT = 'SET_PAGE_TREATMENT';
const SET_UPDATE_DATA_TREATMENT = 'SET_UPDATE_DATA_TREATMENT';
const SET_BUSCADOR_TREATMENT = 'SET_BUSCADOR_TREATMENT';
const SET_FILTRO_TREATMENT = 'SET_FILTRO_TREATMENT';

const listar = (page = 1) =>  (dispatch, getStore) => {
    dispatch({type: LOADER_TREATMENT, cargando: true});
    const store = getStore();
    const search = store.treatments.buscador;
    const filtro = store.treatments.filtro_treatments;
    let params = {page, search};
    if(filtro){
        params[''] = filtro
    }

    api.get(`${url}`, params).catch((error) => {
        dispatch({type: LOADER_TREATMENT, cargando: false});
        Swal(
            'Error',
            error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).then((data) => {
        if(data){
            dispatch({type: SET_DATA_TREATMENT, data});
            dispatch({type: SET_PAGE_TREATMENT, page});
        }
        dispatch({type: LOADER_TREATMENT, cargando: false});
    })
};

const detail = id => (dispatch, getState) =>{
    dispatch({type: LOADER_TREATMENT, cargando: true});
    api.get(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_TREATMENT, cargando: false});
        if(error.statusCode === 404){
            dispatch(push('/treatments'))
        }
    }).then((data) => {
        dispatch({type: LOADER_TREATMENT, cargando: false});
        if(data){
            console.log("detail: ", data);
            dispatch({type: SET_UPDATE_DATA_TREATMENT, updateData: data});
            dispatch(initializeForm('treatment', data))
        }
    })
}

const create = () => (dispatch, getStore) => {
    const formData = getStore().form.treatment.values;
    dispatch({type: LOADER_TREATMENT, cargando: true})

    api.post(`${url}`, formData).then((data) => {
        dispatch({type: LOADER_TREATMENT, cargando: false})
        Swal('Éxito', 'Se ha creado el rol.', 'success')
        .then(() => {
            dispatch(push('/treatments'))
        })
    }).catch((error) => {
        dispatch({type: LOADER_TREATMENT, cargando: false})
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).finally(() => {
        dispatch({type: LOADER_TREATMENT, cargando: false})
    });
};

const update = () => (dispatch, getStore) => {
    const formData = _.cloneDeep(getStore().form.treatment.values);
    dispatch({type: LOADER_TREATMENT, cargando: true});
    api.put(`${url}/${formData.id}`, formData)
    .then((data) => {
        dispatch({type: LOADER_TREATMENT, cargando: false});
        if(data){
            Swal(
                'Éxito',
                'Datos editados correctamente.',
                'success'
            ).then(() => {
                dispatch(push('/treatments'));
            })
        }
    })
    .catch((error) =>{
        dispatch({type: LOADER_TREATMENT, cargando: false});
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, verifique los datos.',
            'error'
        )
        if(error.statusCode === 404){
            dispatch(push('/treatments/create'));
        }
    })
}

const destroy = (id) => (dispatch, getStore) => {
    dispatch({type: LOADER_TREATMENT, cargando: true});
    api.eliminar(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_TREATMENT, cargando: false});
        Swal('Error', 'No se ha logrado borrar el registro.', 'error')
            .then(() => {
                dispatch(listar(1));
            })
    }).then((data) => {
        dispatch({type: LOADER_TREATMENT, cargando: false});
        Swal('Éxito', 'Se ha eliminado correctamente.', 'success')
            .then(() => {
                dispatch(listar(1));
            })
    })
}

const search = (search) => (dispatch) => {
    dispatch({type: SET_BUSCADOR_TREATMENT, buscador: search});
    dispatch(listar(1));
};

const filtro = (filtro) => (dispatch, getStore) => {
    if (filtro == 0){
        filtro = null
    }
    dispatch({type: SET_FILTRO_TREATMENT, filtro_treatments: filtro});
    dispatch(listar(1));
};

export const actions = {
    listar,
    create,
    update,
    detail,
    destroy,
    search,
    filtro,
};

export const reducer = {
    [LOADER_TREATMENT]: (state, { cargando }) => {
        return {...state, cargando }
    },
    [SET_DATA_TREATMENT]: (state, { data }) => {
        return {...state, data }
    },
    [SET_PAGE_TREATMENT]: (state, { page }) => {
        return {...state, page }
    },
    [SET_UPDATE_DATA_TREATMENT]: (state, { updateData }) => {
        return {...state, updateData }
    },
    [SET_BUSCADOR_TREATMENT]: (state, { buscador }) => {
        return {...state, buscador }
    },
    [SET_FILTRO_TREATMENT]: (state, { filtro_treatments }) => {
        return {...state, filtro_treatments }
    },
};

export const initialState = {
    cargando: false,
    page: 1,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: [],
    },
    buscador: '',
    filtro_treatments: null,
    updateData: {},
};

export default handleActions(reducer, initialState)